import '../plugins/TinySmoothScrollPlugin.js';
import '../plugins/AjaxFiltersPlugin.js';
import '../plugins/LoadMorePlugin.js';
import '../plugins/FlexmasonryPlugin.js';
import '../plugins/ImageLoadedPlugin.js';
import {initFlexmasonryTween} from './GSAP.js';

// filters init
export default function initAjaxFilters() {
	jQuery('.ajax-filters-container').formAjaxLoader({
		form: 'form.filter-box',
		newHolderSelector: '.ajax-filter-holder',
		busyClass: 'is-busy',
		preAppendClass: 'new-item',
		pagerLink: '.pagination a',
		changeMode: true
	}).on('FormAjaxLoader/appended', function(e, obj) {
		jQuery(this).find('.load-more-box-scroll').loadMore({
			newContentTarget: '.ajax-load-content',
			newContentSelector: '.ajax-load-content',
			linkSelector: 'a.load-more',
			additionBottomOffset: 100,
			scroll: true
		});

		jQuery(this).find('.load-more-box').loadMore({
			newContentTarget: '.ajax-load-content',
			newContentSelector: '.ajax-load-content',
			linkSelector: 'a.load-more'
		});
	});

	jQuery('.ajax-filters-container-paginated').formAjaxLoader({
		form: 'form.filter-box',
		newHolderSelector: '.ajax-filter-holder',
		busyClass: 'is-busy',
		preAppendClass: 'new-item',
		pagerLink: '.pagination a',
		changeMode: true,
	}).on('FormAjaxLoader/appended', function(e, obj) {
		var $container = jQuery(this).removeClass('not-found');
		var resultCount = $container.find('[data-result-count]').data('resultCount') || 0;

		if (!resultCount) {
			$container.addClass('not-found');
		}

		// update search result count
		$container.find('[data-result-count-holder]').html(resultCount);

		// update pagination
		$container.find('.js-ajax-pagination-placeholder').html(obj.$newContent.filter('.js-ajax-pagination'));

		// init FlexMasonry for new content
		FlexMasonry.init(this.querySelectorAll('.js-flexmasonry-filter-grid'), {
			responsive: true,
			breakpointCols: {
				'min-width: 1200px': 3,
				'min-width: 768px': 2,
				'min-width: 320px': 1,
			},
		});

		jQuery(this).find('.js-flexmasonry-filter-grid').each((i, grid) => {
			jQuery(grid).imagesLoaded(() => {
				FlexMasonry.refresh(grid);
				initFlexmasonryTween($container);
			});
		});
	}).on('FormAjaxLoader/loaded', function(e, obj) {
		window.TinySmoothScroll && TinySmoothScroll(jQuery(this).offset().top - 50);
	});

	jQuery('.filters-content-drop .filters-main-opener:not(.drop-heading)').on('click', function() {
		var $filtersParent = jQuery(this).closest('.ajax-filters-container-paginated');
		$filtersParent.length && window.TinySmoothScroll && TinySmoothScroll($filtersParent.offset().top, ('scrollBehavior' in document.documentElement.style) ? 0 : 600);
	});

	jQuery('.filter-box').on('change updateCheckedCount', function() {
		const $container = jQuery(this);
		const checkedCount = $container.find('.filters-list input:checked').length;

		$container.find('[data-checked-count-holder]').html(checkedCount);
	}).trigger('updateCheckedCount');
}
